import React, { useState } from 'react'
import Footer from '../Components/Footer'
import Header from '../Components/Header'
import SideBar from '../Components/Sideabar'

const terms = [
    {
        text: 'Welcome to Hulluware ("Website," "Platform," "Service"). These Terms and Conditions ("Terms") govern your use of our website and services. By accessing or using our Platform, you agree to be bound by these Terms. If you do not agree with any part of these Terms, you must not use our services.'
    },
    {
        title: '1. Acceptance of Terms',
        text: 'By using this Platform, you confirm that you are at least 18 years old or have the consent of a legal guardian. You agree to comply with these Terms and all applicable laws and regulations. Failure to comply may result in immediate termination of your access. For Minors: If you are under the age of 18, you may only use the Platform with the consent and supervision of a parent or legal guardian. By using the Platform, you confirm that you have obtained such consent.'
    },
    {
        title: '2. User Accounts',
        text: `Registration: To access certain features, you must create an account. You agree to provide accurate, complete, and up-to-date information. Any false information may result in account suspension or termination.
        
Account Security: You are solely responsible for maintaining the confidentiality of your account credentials and for all activities under your account. Notify us immediately of any unauthorized use or security breaches.
        
Termination: We reserve the right to suspend or terminate your account at our sole discretion, without notice, for any violation of these Terms.`
    },
    {
        title: '3. Use of the Platform',
        text: `Eligibility: Our services are available only to individuals who can form legally binding contracts. By using the Platform, you represent and warrant that you meet this requirement.
        
Prohibited Activities: You agree not to:
        
Use the Platform for any illegal, fraudulent, or unauthorized purpose.
Copy, reproduce, distribute, or modify any content without explicit written permission.
Reverse-engineer, decompile, or disassemble any part of the Platform.
Engage in any activity that disrupts, interferes with, or burdens the Platform's functionality, servers, or networks.
Use automated tools (e.g., bots, scrapers, scripts) to access, monitor, or copy any part of the Platform.
Harass, abuse, or harm other users or our employees.
Monitoring: We reserve the right to monitor user activity and take appropriate action, including account termination, for any violations.
        `
    },
    {
        title: '4. Course Enrollment and Payments',
        text: `Course Access: Upon payment, you will gain access to the enrolled course(s) for the specified duration. Access is non-transferable and limited to the registered user only.
Refunds: All payments are final. No refunds will be issued except as explicitly stated in our Refund Policy.
Pricing: We reserve the right to change course prices at any time without prior notice. Changes will not affect already purchased courses.
Charge backs: Any attempt to initiate a chargeback or dispute a valid payment will result in immediate account suspension and legal action to recover owed amounts.
        `
    },
    {
        title: '5. Intellectual Property',
        text: `Ownership: All content on the Platform, including courses, videos, text, graphics, and software, is owned by Hulluware or its licensors and is protected by copyright, trademark, and other intellectual property laws.
License: You are granted a limited, non-exclusive, non-transferable, revocable license to access and use the content for personal, non-commercial purposes only. Any unauthorized use will result in legal action.
User Content: By submitting content (e.g., comments, reviews), you grant us an irrevocable, worldwide, royalty-free license to use, modify, distribute, and display such content for any purpose.
        `
    },
    {
        title: '6. Privacy',
        text: `Your use of the Platform is subject to our Privacy Policy, which explains how we collect, use, and protect your personal information. By using the Platform, you consent to the collection and use of your data as outlined in the Privacy Policy.`
    },
    {
        title: '7. Limitation of Liability',
        text: `No Warranty: The Platform and its content are provided "as is" without warranties of any kind, either express or implied. We do not guarantee that the Platform will be error-free, secure, or uninterrupted.
        Limitation: In no event shall Hulluware, its affiliates, or employees be liable for any indirect, incidental, consequential, or punitive damages arising from your use of the Platform, including but not limited to loss of data, profits, or business opportunities.`
    },
    {
        title: '8. Indemnification',
        text: `You agree to indemnify, defend, and hold harmless Hulluware, its affiliates, employees, and partners from any claims, damages, liabilities, costs, or expenses (including legal fees) arising from:
        Your use of the Platform.
        Your violation of these Terms.
        Your infringement of any third-party rights, including intellectual property rights.`
    },
    {
        title: '9. Modifications to Terms',
        text: `We reserve the right to update these Terms at any time without prior notice. Changes will be effective immediately upon posting on the Platform. Your continued use of the Platform constitutes acceptance of the revised Terms. It is your responsibility to review these Terms periodically.`
    },
    {
        title: '10. Governing Law and Dispute Resolution',
        text: `Governing Law: These Terms are governed by the laws of Ethiopia, without regard to its conflict of law principles.
        Dispute Resolution: Any disputes arising from these Terms or your use of the Platform shall be resolved exclusively in the courts of Addis Ababa, Ethiopia. You agree to submit to the personal jurisdiction of these courts.
        Class Action Waiver: You waive any right to participate in a class action lawsuit or class-wide arbitration against Hulluware.`
    },
    {
        title: '11. Termination',
        text: `We reserve the right to terminate or suspend your access to the Platform at any time, without notice, for any reason, including but not limited to:
        Violation of these Terms.
        Engaging in fraudulent or illegal activities.
        Initiating chargebacks or payment disputes.
        Upon termination, you will lose access to all courses and content, and no refunds will be issued.`
    },
    {
        title: '12. Miscellaneous',
        text: `Entire Agreement: These Terms constitute the entire agreement between you and Hulluware and supersede any prior agreements or understandings.
        Severability: If any provision of these Terms is found to be invalid or unenforceable, the remaining provisions will remain in full force and effect.
        Waiver: Our failure to enforce any provision of these Terms does not constitute a waiver of that provision or any other provision.`
    },
    {
        title: '13. Contact Us',
        text: `If you have any questions about these Terms, please contact us at:
        Email: info@hulluware.com
        Phone: +251962444466
        Address: Addis Ababa, Ethiopia`
    }
]

export default function Terms() {
    return (
      <div className='w-full flex bg-[#f2f2f2] h-screen overflow-hidden'>
        <div className='flex-1 flex flex-col overflow-auto pt-[60px]'>
            <Header />
            <div className='flex-1 p-4'>
                <h1 className='text-center text-[30px] font-bold'>Terms and Conditions</h1>
                {terms.map(term => (
                    <>
                        {term.title && <p className='text-sm text-center font-bold text-md mt-4'>{term.title}</p>}
                        <p className='text-sm mt-2 whitespace-pre-wrap text-center text-justify'>{term.text}</p>
                    </>
                ))}
            </div>
            <Footer />
        </div>
      </div>
    )
  }